<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="4">
        <el-input v-model="form.batchCode" size="small" placeholder="批次编码" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.batchName" size="small" placeholder="批次名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-select  v-model="form.isRelate" clearable placeholder="是否关联">
          <el-option label="未关联" :value="1"></el-option>
          <el-option label="已关联" :value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.orderId" size="small" placeholder="订单号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.accountName" size="small" placeholder="账号名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.taskName" size="small" placeholder="任务名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
    </el-row>
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="12">
        <el-date-picker
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          v-model="timeData"
          type="datetimerange"
          range-separator="~"
          start-placeholder="最早发布时间"
          end-placeholder="最晚发布时间">
        </el-date-picker>
      </el-col>
      
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">外部平台数据总数：{{ page.total }}条</div>
        <div>
          <!-- <el-badge style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="batchClick">批量关联投放记录</el-button>
          </el-badge>
          <el-badge style="margin:0 25px;"  class="item">
            <el-button  type="primary" size="small" @click="batchSubmit">批量开票</el-button>
          </el-badge> -->
          <el-button v-if="permissions.platform_import" type="primary" size="small" @click="relateImportClick">批量关联</el-button>
          <el-button v-if="permissions.platform_import" type="primary" size="small" @click="batchImportClick">批量导入</el-button>
          <el-button type="primary" size="small" @click="onExport">导出</el-button>
        </div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" :selectable='selectable' width="55" align="center"></el-table-column>
        <el-table-column label="批次编码" prop="batchCode" align="center"></el-table-column>
        <el-table-column label="批次名称" prop="batchName" align="center"></el-table-column>
        <el-table-column label="账单归属" prop="orderOwnerShip" align="center"></el-table-column>
        <el-table-column label="订单号" prop="orderId" align="center"></el-table-column>
        <el-table-column label="任务名称" prop="taskName" align="center"></el-table-column>
        <el-table-column label="账号名称" prop="accountName" align="center"></el-table-column>
        <el-table-column label="发布时间/订单时间" min-width="120" prop="publishTime" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishTime && scope.row.publishTime.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column label="订单金额" prop="orderAccount" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.orderAccount) }}
          </template>
        </el-table-column>
        <el-table-column label="投放记录" prop="putInCode" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.putInCode" type="text" size="small" @click="onDel(scope.row.id)">删除</el-button>
            <!-- 关联投放记录按钮 判断投放记录是否存在 -->
            <el-button v-if="scope.row.relateTag==0&&scope.row.putInCode" type="text" size="small" @click="associatedRecord(scope.row.id,scope.row)">重新关联投放记录</el-button>
            <el-button v-if="scope.row.relateTag==0&&!scope.row.putInCode" type="text" size="small" @click="associatedRecord(scope.row.id,scope.row)">关联投放记录</el-button>
            <!-- 无关联投放记录 -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div><!-- 分页 -->
      <!-- 关联框架投放记录 -->
      <recordFramework ref="recordFramework" :recordValue="recordValue" @customChooseSave="customChooseSave" :recordDialog="recordDialog" @recordClose="recordClose"></recordFramework>
      <platformOrderBatch ref="platformOrderBatch"  @batchSave="batchSave" :batchDialog="batchDialog" @batchClose="batchClose"></platformOrderBatch>
   
    </div>
    <!-- 导入投放记录 -->
    <el-dialog
      title="导入外部平台记录"
      :visible.sync="dialogVisible"
      width="50%">
      <el-form v-if="promptShow" label-position="top" size="small" :model="ruleForm" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <div>
          <el-form-item>
            <el-input clearable size="small" v-model="batchName" placeholder="批次名称" ></el-input>
          </el-form-item>
          
          <el-form-item style="height:70px;" label="外部平台文档" prop="path" class="block-form-item w-25">
            <el-upload style="margin-right:60px;" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="getBeforeUpload">
              <el-button type="primary">上传文档</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item style="height:70px;" label="外部平台导入模板" prop="path" class="block-form-item w-70">
            <a href="/files/外部平台导入模板.xlsx" class="link chaochu" download="外部平台导入模板.xlsx">外部平台导入模板.xlsx</a>
          </el-form-item>
        </div>
        <div style="color:#409eff;" v-if="fileData">{{fileData.name}}</div>
        <div class="anniuFlex" style="margin-top:20px;text-align:center;">
					<el-button style="margin-right:60px;" v-if="beforeShowNew" @click="before_UploadOne" type="primary">导 入</el-button>
          <el-button type="primary" style="margin-right:60px;" v-else :loading="true">导入中</el-button>
          <el-button plain @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-form>
      <div v-else style="margin-top:-10px;text-align:center;">
        <div v-if="successShow==1" class="el-icon-success" style="font-size:60px;color:#67c23a;"></div>
        <div v-if="successShow==2" class="el-icon-error" style="font-size:60px;color:#f5212e;"></div>
        <div v-if="successShow==3" class="el-icon-warning" style="font-size:60px;color:#faad14;"></div>
        <h4 style="font-size:20px;">{{successShow==1?'导入成功':successShow==2?'导入失败':'部分导入成功'}}</h4>
        <div v-if="successShow == 3" style="padding-bottom:20px;">请导出失败外部平台记录，检查导入格式后再重新导入</div>
        <div class="box-flex">
          <div>导入成功：{{uploadData.successCount}}条</div>
          <div style="margin-left:100px;">导入失败：{{uploadData.failCount}}条</div>
        </div>
        <div>
          <el-button v-if="successShow == 1" @click="dialogVisible = false" type="primary" style="margin-right:60px;" size="small">继续导入</el-button>
          <!-- <el-button type="primary" @click="exportFailure" style="margin-right:60px;">导出失败记录</el-button> -->
          <el-button v-else type="primary" size="small" @click="exportWord" style="margin-right:60px;">导出失败记录</el-button>
          <el-button plain size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 批量关联投放记录 -->
    <el-dialog
      title="批量关联投放记录"
      :visible.sync="dialogVisibleNew"
      width="50%">
      <el-form v-if="promptShowNew" label-position="top" size="small" :model="ruleFormNew" ref="ruleFormNew" label-width="140px" class="demo-ruleForm">
        <div>
          <el-form-item style="height:70px;" label="关联关系文档" prop="path" class="block-form-item w-25">
            <el-upload style="margin-right:60px;" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="getBeforeUploadNew">
              <el-button type="primary">上传文档</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item style="height:70px;" label="关联关系导入模板" prop="path" class="block-form-item w-70">
            <a href="/files/关联关系导入模板.xlsx" class="link chaochu" download="关联关系导入模板.xlsx">关联关系导入模板.xlsx</a>
          </el-form-item>
        </div>
        <div style="color:#409eff;" v-if="fileDataNew">{{fileDataNew.name}}</div>
        <div class="anniuFlex" style="margin-top:20px;text-align:center;">
					<el-button style="margin-right:60px;" v-if="beforeShowNew" @click="before_UploadOneNew" type="primary">导 入</el-button>
          <el-button type="primary" style="margin-right:60px;" v-else :loading="true">导入中</el-button>
          <el-button plain @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-form>
      <div v-else style="margin-top:-10px;text-align:center;">
        <div v-if="successShowNew==1" class="el-icon-success" style="font-size:60px;color:#67c23a;"></div>
        <div v-if="successShowNew==2" class="el-icon-error" style="font-size:60px;color:#f5212e;"></div>
        <div v-if="successShowNew==3" class="el-icon-warning" style="font-size:60px;color:#faad14;"></div>
        <h4 style="font-size:20px;">{{successShowNew==1?'导入成功':successShowNew==2?'导入失败':'部分导入成功'}}</h4>
        <div v-if="successShowNew == 3" style="padding-bottom:20px;">请导出失败外部平台记录，检查导入格式后再重新导入</div>
        <div class="box-flex">
          <div>导入成功：{{uploadDataNew.successCount}}条</div>
          <div style="margin-left:100px;">导入失败：{{uploadDataNew.failCount}}条</div>
        </div>
        <div>
          <el-button v-if="successShowNew == 1" @click="dialogVisibleNew = false" type="primary" style="margin-right:60px;" size="small">继续导入</el-button>
          <!-- <el-button type="primary" @click="exportFailure" style="margin-right:60px;">导出失败记录</el-button> -->
          <el-button v-else type="primary" size="small" @click="exportWordNew" style="margin-right:60px;">导出失败记录</el-button>
          <el-button plain size="small" @click="dialogVisibleNew = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import xlsx from "xlsx";
import validate from "@/util/validate";
import util from "@/util/util";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
import { deliveryConfig } from "@/const/config/delivery";
import {
  listPlatfrom,
  exportPlatform,
  delPlatform,
  relateRecord,
  putPlatformImport,
  relateImport
} from "@/api/business/platform";
import { mapGetters } from "vuex";
import recordFramework from "@/components/common/recordFramework";
import platformOrderBatch from "@/components/common/platformOrderBatch";
import { qiniuToken } from "@/api/index";
import * as qiniu from "qiniu-js";
export default {
  components: {
    recordFramework,
    platformOrderBatch
  },
  data() {
    return {
      beforeShow:true, //导入按钮控制
      moban:"/files/外部平台导入模板.xlsx",
      mediaConfig: mediaConfig,
      contractConfig: contractConfig,
      deliveryConfig: deliveryConfig,
      recordDialog:false,
      batchDialog:false,
      dialogVisible:false,
      batchName:"" ,
      timeData:[],
      ruleForm:{
        path:"",
        name:"",
        desc:"",
      },
      
      form: {
        batchCode:"",
        batchName:"" ,
        orderId: "",
        accountName: "",
        taskName: "",
        publishStartTime:"" ,
        publishEndTime:"",
        isRelate:"",
      },
      updateParam:{},

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      multiSelectList:[],
      id:"",
      recordValue:{},
      batchType:"",
      wbptValue:{},
      fileData:"",
      promptShow:true,
      successShow:"",
      uploadData:"",
      sheetHeader:["*账单归属","*订单号","*任务名称","*账号名称","发布时间/订单时间","*订单金额","*失败原因"],
    
      beforeShowNew:true, //导入按钮控制
      dialogVisibleNew:false,
      ruleFormNew:{
        path:"",
        name:"",
        desc:"",
      },
      uploadDataNew:"",
      promptShowNew:true,
      successShowNew:"",
      fileDataNew:"",
    };

  },
  mounted() {
    this.getList();
  },
  methods: {
    //导出开票列表
			exportWord(){
				var data = this.uploadData.failDataList
        let dataTable = []
        for (let i in data) {
          let obj = {
            '账单归属': data[i].orderOwnerShip,
            '订单号': data[i].orderId,
            '任务名称': data[i].taskName,
            '账号名称': data[i].accountName,
            '发布时间': data[i].publishTime,
            '订单金额': data[i].orderAccount,
            '失败原因': data[i].reason
            
          }
          dataTable.push(obj);
				}
				  //生成表格
				  var sheet = xlsx.utils.json_to_sheet(dataTable);
				  var tmpdata = xlsx.utils.sheet_add_json(sheet, dataTable, { origin: "A2" });
				  //给A1单元格赋值
				  tmpdata["A1"] = {
				    t: "s",
				    v: `投放记录导入文档说明：
1，账单归属：【必填】
2，订单号：【必填】
3，任务名称：【必填】
4，账号名称：【必填】
5，发布时间：仅支持输入两种时间格式，示例：2021/04/28 和 2021-04-28
6，订单金额：【必填】`
				  };
				  // 设置A1标题字体样式
				  tmpdata["A1"].s = {
            font: { sz: 10},
            alignment: { vertical: "center", wrapText: true },
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "00b050" }},
				  };
				  //单元格合并
				  tmpdata["!merges"] = [{ 
				    //合并单元格 index都从0开始
				    s: { //s开始
				      c: 0, //开始列
				      r: 0 //开始行
				    },
				    e: { //e结束
				      c: 18, //结束列
				      r: 0 //结束行
				    }
				  }]
          // 设置B2单元格样式
          let colWidthList = []
          this.sheetHeader.forEach((v, index) => {
            tmpdata[this.convert10to26(index + 1) + 2] = {
              t: "s", //类型 s字符串 n数字
              v:v,
              s: {
                font: { sz: 11, color: { rgb: "ff0000" }},
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "fcd5b4" }}
              }
            }
            colWidthList[index] = index==2 || index==10 || index==16?{ wpx: 100 }:{ wpx: 80 };
          })
        tmpdata['!cols'] = colWidthList;
        tmpdata['!rows'] = [{ hpx: 1000 }];
				const filename = `外部平台记录失败数据`
        console.log(tmpdata)
				this.openDownloadDialog(this.sheet2blob(tmpdata), `${filename}.xlsx`);
			},
			sheet2blob(sheet, sheetName) {
			  sheetName = sheetName || 'sheet1';
			  var workbook = {
			    SheetNames: [sheetName],
			    Sheets: {},
			  };
			  workbook.Sheets[sheetName] = sheet; // 生成excel的配置项
			
			  var wopts = {
			    bookType: 'xlsx', // 要生成的文件类型
			    bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
			    type: 'binary'
			  };
			  var wbout = XLSXStyle.write(workbook, wopts);
			  var blob = new Blob([s2ab(wbout)], {
			    type: "application/octet-stream"
			  }); // 字符串转ArrayBuffer
			  function s2ab(s) {
			    var buf = new ArrayBuffer(s.length);
			    var view = new Uint8Array(buf);
			    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
			    return buf;
			  }
			  return blob;
			},
			
			openDownloadDialog(url, saveName) {
			  let href = URL.createObjectURL(url)
			  let a = document.createElement('a');
			  a.href = href;
			  a.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
			  document.body.appendChild(a)
			  a.click()
			  document.body.removeChild(a)
			  setTimeout(() => {
			    URL.revokeObjectURL(url)
			  }, 200);
			},
      convert10to26(num){
        var str = "";
        while (num > 0) {
          var m = num % 26;
          if (m == 0) {
            m = 26;
          }
          str = String.fromCharCode(m + 64) + str;
          num = (num - m) / 26;
        }
        return str;
    },
    //导出失败数据
    exportFailure(){
      const ExportJsonExcel = require('js-export-excel')
      var option={};
      option.fileName = '投放记录失败数据'
      option.datas=[{
        sheetData:this.uploadData.failDataList,//data就是传入的后台数据 作为的参数
        sheetHeader:this.sheetHeader//自定义表头
      }]
      var toExcel=new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
    before_UploadOne(){
      if(this.fileData&&this.batchName){
        this.beforeShow = false;
        let formData = new FormData();
        formData.append("file", this.fileData);
        putPlatformImport(formData,this.batchName).then(res=>{
          this.beforeShow = true;
          console.log('======导入数据返回======',res)
          if(res.code === 1){
            //文档没数据
            if(res.data.failCount == 0 && res.data.successCount == 0){
              this.$message.warning('导入模版数据为空,请上传正确的模版数据!');
              this.dialogVisible = false;
              this.getList();
              return;
            }
            this.uploadData = res.data;
            // 导入成功进入
            if(res.data.failCount == 0){
              this.promptShow = false;
              this.successShow = 1;
              this.getList();
              return
            }
            //导入失败进入
            if(res.data.successCount == 0){
              this.promptShow = false;
              this.successShow = 2;
              this.getList();
              return
            }
            //部分导入成功失败进入
            if(res.data.failCount>0 && res.data.successCount>0){
              this.promptShow = false;
              this.successShow = 3;
              this.getList();
              return
            }
          }
        })
      }else{
        this.beforeShow = true;
        if(this.batchName){
          this.$message({
          message: '请上传投放记录模版!',
          type: 'warning'
          });
        }else{
          this.$message({
          message: '请填写上传批次名称!',
          type: 'warning'
          }); 
        }
        
      }
    },
    getBeforeUpload(file){
      this.fileData = file
      console.log('======44444=======',file)
    },
    //关联投放记录
    customChooseSave(item){
      var ids = [] ;
      if(this.batchType == 1){
        this.multiSelectList.forEach(element => {
          ids.push(element.id)
        });
      }else{
        ids = [this.id]
      }

      relateRecord(ids,item).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '关联投放记录成功!',
            type: 'success'
          });
          this.recordDialog = false
          this.getList();
        }
        console.log('=======关联======',res)
      })
    },
//关联投放记录
    batchSave(item){
      var ids = [] ;
      if(this.batchType == 1){
        this.multiSelectList.forEach(element => {
          ids.push(element.id)
        });
      }else{
        ids = [this.id]
      }

      relateRecord(ids,item).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '关联投放记录成功!',
            type: 'success'
          });
          this.recordDialog = false
          this.getList();
        }
        console.log('=======关联======',res)
      })
    },

    //多选禁用
    selectable(row,index){
      if(row.contractName){
        if( row.contractStatus === contractConfig.Status.Starting 
          || row.contractStatus === contractConfig.Status.FailStarting 
          || row.contractStatus === contractConfig.Status.Processing
          || row.contractStatus === contractConfig.Status.EndAssessFail
          || row.contractStatus === contractConfig.Status.CloseAssessFail){
          return true
        }else{
          return false
        }
      }else{
        return true
      }
    },
    batchImportClick(){
      this.batchName = "" ;
      this.fileData = "";
      this.promptShow = true;
      this.dialogVisible = true;
      this.beforeShow = true ;
    },
    //上传文件成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    //上传文件失败
    uploadError(res, file) {
      console.log("error", res, file);
    },
    //文件上传
    beforeUpload(file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error("文件大小不能超过500M");
        return false;
      }
      qiniuToken()
        .then((res) => {
          let that = this;
          let fileName = Date.now() + file.name;
          var observable = qiniu.upload(file, fileName, res.data);
          observable.subscribe({
            next(res) {},
            error(error) {
              this.$message.error("上传失败");
            },
            complete: (complete) => {
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              this.$set(this.ruleForm, "name", file.name);
              this.$set(this.ruleForm, "path", qiniuBaseUrl + complete.key);
            },
          });
        })
        .catch((error) => {});
      return false;
    },
    //批量关联投放记录
    batchClick(){
      this.batchType = 1;
      this.recordDialog = true;
      this.$refs.recordFramework.recordShow = false;
    },

    //批量关联投放记录
    batchSubmit(){
      this.batchDialog = true;
      this.$refs.recordFramework.recordShow = false;
    },
    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },
    //关联投放记录
    associatedRecord(id,data){
      console.log('===AAA===',data)
      this.recordValue = {
        code:data.putInCode,
      }
      this.id = id;
      this.recordDialog = true;

    },
    recordClose(){
      this.recordDialog = false;
    },
    batchClose(){
      this.batchDialog = fasle ;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        orderId: "",
        accountName: "",
        taskName: "",
        publishStartTime:"" ,
        publishEndTime:"" ,
        timeData: []
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      if(this.timeData){
        this.form.publishStartTime = this.timeData[0]
        this.form.publishEndTime = this.timeData[1]
      }else{
        this.form.publishStartTime = ""
        this.form.publishEndTime = ""
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      listPlatfrom(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 删除
     */
    onDel(id) {
      this.$confirm("删除将无法恢复，确认删除该外部平台记录吗？", "确认删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "",
        customClass: "msgbox contnt-center",
      })
        .then(() => {
          delPlatform({ id }).then((res) => {
            console.log(res) ;
            this.$message.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 导出
     */
    onExport() {
      let queryObj = validate.removeFilterNull(this.form);
      exportPlatform(queryObj).then((res) => {
        const blob = new Blob([res.data]);
        let fileName = res.headers["content-disposition"].split("filename=")[1];
        fileName = decodeURI(fileName);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const linkNode = document.createElement("a");
          linkNode.download = fileName; //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none";
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click(); //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }

        setTimeout(() => {
          this.$message.success("导出成功，等待文件下载完毕");
        }, 500);
      });
    },
    /**
     * 展示原因
     * @param reason 原因
     */
    onShowReason(reason) {
      reason = reason || "";
      this.$alert(reason, "投放失败原因", {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 跳转到编辑页
     */
    toEdit(id) {
      let router = this.$router.push({
        path: "/business/delivery-log/edit",
        query: { id },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    /**
     * 跳转到查看页
     */
    toShow(id) {
      let router = this.$router.push({
        path: "/business/delivery-log/show",
        query: { id,type:'show' },
      });
      window.open(router.href, "_blank");
    },

    //导出开票列表
    exportWordNew(){
      var data = this.uploadDataNew.failDataList
      let dataTable = []
      for (let i in data) {
        let obj = {
          '投放记录编号': data[i].putInCode,
          '订单号': data[i].orderId,
          '失败原因': data[i].reason
          
        }
        dataTable.push(obj);
      }
        //生成表格
        var sheet = xlsx.utils.json_to_sheet(dataTable);
        var tmpdata = xlsx.utils.sheet_add_json(sheet, dataTable, { origin: "A2" });
        //给A1单元格赋值
        tmpdata["A1"] = {
          t: "s",
          v: `投放记录导入文档说明：
  1，投放记录编号：【必填】
  2，订单号：【必填】`
        };
        // 设置A1标题字体样式
        tmpdata["A1"].s = {
          font: { sz: 10},
          alignment: { vertical: "center", wrapText: true },
          fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "00b050" }},
        };
        //单元格合并
        tmpdata["!merges"] = [{ 
          //合并单元格 index都从0开始
          s: { //s开始
            c: 0, //开始列
            r: 0 //开始行
          },
          e: { //e结束
            c: 18, //结束列
            r: 0 //结束行
          }
        }]
        // 设置B2单元格样式
        let colWidthList = []
        this.sheetHeader.forEach((v, index) => {
          tmpdata[this.convert10to26(index + 1) + 2] = {
            t: "s", //类型 s字符串 n数字
            v:v,
            s: {
              font: { sz: 11, color: { rgb: "ff0000" }},
              alignment: { horizontal: "center", vertical: "center", wrapText: true },
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "fcd5b4" }}
            }
          }
          colWidthList[index] = index==2 || index==10 || index==16?{ wpx: 100 }:{ wpx: 80 };
        })
      tmpdata['!cols'] = colWidthList;
      tmpdata['!rows'] = [{ hpx: 1000 }];
      const filename = `外部平台记录失败数据`
      console.log(tmpdata)
      this.openDownloadDialog(this.sheet2blob(tmpdata), `${filename}.xlsx`);
    },
    
    before_UploadOneNew(){
      if(this.fileDataNew){
        this.beforeShowNew = false;
        let formData = new FormData();
        formData.append("file", this.fileDataNew);
        relateImport(formData).then(res=>{
          this.beforeShowNew = true;
          console.log('======导入数据返回======',res)
          if(res.code === 1){
            //文档没数据
            if(res.data.failCount == 0 && res.data.successCount == 0){
              this.$message.warning('导入模版数据为空,请上传正确的模版数据!');
              this.dialogVisibleNew = false;
              this.getList();
              return;
            }
            this.uploadDataNew = res.data;
            // 导入成功进入
            if(res.data.failCount == 0){
              this.promptShowNew = false;
              this.successShowNew = 1;
              this.getList();
              return
            }
            //导入失败进入
            if(res.data.successCount == 0){
              this.promptShowNew = false;
              this.successShowNew = 2;
              this.getList();
              return
            }
            //部分导入成功失败进入
            if(res.data.failCount>0 && res.data.successCount>0){
              this.promptShowNew = false;
              this.successShow = 3;
              this.getList();
              return
            }
          }
        })
      }else{
        this.$message({
        message: '请上传投放记录模版!',
        type: 'warning'
        });
        
      }
    },
    getBeforeUploadNew(file){
      this.fileDataNew = file
      console.log('======44444=======',file)
    },

    relateImportClick(){
      this.fileDataNew = "";
      this.promptShowNew = true;
      this.dialogVisibleNew = true;
      this.beforeShowNew = true ;
    },



    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
.anniuFlex{
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box-flex{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.block-form-item {
  &.w-25 {
    display: inline-block;
    width: 24%;
    margin-right: 1%;
    height: 64px;
  }
  &.w-70 {
    display: inline-block;
    width: 70%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
</style>